const modalService = () => {
    const d = document;
    const body = d.querySelector("body");
    const modalLinks = d.querySelectorAll(".modal-link");

    // attach click event to all modal triggers
    for (let modalLink of modalLinks) {
        triggerEvent(modalLink);
    }

    function triggerEvent(modalLink) {
        modalLink.addEventListener("click", (e) => {
            e.preventDefault();

            console.log("open modal");

            const modal = d.getElementById("modal");
            const modalBody = modal.querySelector(".modal-body");
            const closeBtn = modal.querySelector(".close-modal");

            modal.classList.add("loading");
            modal.classList.toggle("modal-open");
            document.body.classList.toggle("modal-open");

            // load content
            const url = modalLink.href;
            var request = new Request(url, {
                headers: new Headers({
                    "X-Requested-With": "XMLHttpRequest",
                }),
            });

            fetch(request)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        //modal.classList.remove("loading");
                        throw new Error("Seite konnte nicht geladen werden");
                    }
                })
                .then(function (resp) {
                    modalBody.innerHTML = resp;
                })
                .catch(function (err) {
                    console.warn("Something went wrong.", err);
                    modal.classList.remove("loading");
                });

            closeBtn.addEventListener("click", () => {
                modal.classList.remove("modal-open");
                document.body.classList.remove("modal-open");
            });
            modal.addEventListener("click", () => {
                modal.classList.remove("modal-open");
                document.body.classList.remove("modal-open");
            });

            modalBody.addEventListener("click", (e) => e.stopPropagation());

            // Close modal when hitting escape
            body.addEventListener("keydown", (e) => {
                if (e.keyCode === 27) {
                    modal.classList.remove("modal-open");
                    document.body.classList.remove("modal-open");
                }
            });
        });
    }
};

modalService();
